module.exports = __webpack_public_path__ + "fb084c3ad5c6a7395cdf7d126d04a0d5.png";